import {
    initializeApp
} from 'firebase/app';
import {
    getAuth,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword
} from "firebase/auth";
import {
    getAnalytics,
    logEvent
} from "firebase/analytics";
const firebaseConfig = {
    apiKey: "AIzaSyB5PX5o2E_zc7cz7jRHHM4MFaYrIqhW4HI",
    authDomain: "autojoomer-21321.firebaseapp.com",
    databaseURL: "https://autojoomer-21321-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "autojoomer-21321",
    storageBucket: "autojoomer-21321.appspot.com",
    messagingSenderId: "626395898725",
    appId: "1:626395898725:web:2aeca89f0f0c48991c378c",
    measurementId: "G-78TJPL6RVY"
};
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const analytics = getAnalytics();

export const signup = (e) => {
    e.preventDefault();
    let regno = document.getElementById('regno').value.toString().toLowerCase().trim() + "@autojoomer.co";
    regno = regno.trim();
    let password = document.getElementById('password').value.toString().trim();
    let confirmPassword = document.getElementById('confirm').value.toString().trim();
    // checks if the username matches the format and if password is same and >6 characters
    if (validateUsername(regno) && validatePassword(password, confirmPassword)) {
        createUserWithEmailAndPassword(auth, regno, password)
            .then(() => {
                // let user = auth.currentUser
                logEvent(analytics, "signup", {
                    "regno": document.getElementById('regno').value
                });
                alert("Successfully signed up, login on next page.")
                window.location.href = "../login"
            })
            .catch(error => {
                alert(error.message)
            })
    }
}

export const login = (e) => {
    e.preventDefault();
    let regno = document.getElementById('regno').value + "@autojoomer.co";
    let password = document.getElementById('password').value;
    if (password.length < 6) {
        logEvent(analytics, "empty", {
            "regno": document.getElementById('regno').value
        });
        alert("Please enter correct password")
        return;
    }

    signInWithEmailAndPassword(auth, regno, password)
        .then(() => {
            let user = auth.currentUser
            logEvent(analytics, "login", {
                "regno": document.getElementById('regno').value
            });
            alert("Account verified.")

            // TODO redirect to an internal website with link to link to apk
            window.location.href = "../download"
        })
        .catch(error => {
            logEvent(analytics, error.message, {
                "regno": document.getElementById('regno').value
            });
            alert(error.message)
        })
}


const validatePassword = (pass, cfpass) => {
    if (pass.length < 6) {
        logEvent(analytics, "su_empty", {
            "regno": document.getElementById('regno').value
        });
        alert("Please enter password of atleast 6 ChArAcTeRs")
        return false
    } else {
        if (pass === cfpass) {
            return true
        }
        logEvent(analytics, "su_diff", {
            "regno": document.getElementById('regno').value
        });
        alert("Uh-oh, Password and Confirm password do not match")
        return false;
    }
}

const validateUsername = (username) => {
    let pattern = /20(19BCS((000[1-9])|(00[1-9][0-9])|(01[01][0-9])|(012[0-2]))|(20BCS)((000[1-9])|(00[1-9][0-9])|(01[0-8][0-9])|(0190))|(21BCS)((000[1-9])|(00[1-9][0-9])|(01[0-9][0-9]))|(21BCY)((000[1-9])|(00[1-3][0-9])|(004[0-6]))|(20BEC)((000[1-9])|(00[1-3][0-9]))|(21BEC)((000[1-9])|(00[1-3][0-9])|(004[0-4])))/mgi;
    if (pattern.test(username)) return true;
    else alert('Wrong format of roll number.');
    return false;
}